import type { ReactNode } from 'react'
import { ConfirmHost, Toaster } from './Feedback'
import { TooltipProvider } from './Overlay'
import { useColorScheme } from './hooks'

function SchemeSync() {
  // Tema özniteliğini (açık/koyu) kökte tutar; tercih değişince bileşenler yeniden çizilir.
  useColorScheme()
  return null
}

/** Kitin küresel parçaları: ipucu sağlayıcısı, bildirim yığını, onay penceresi, tema. */
export function UIProvider({ children }: { children: ReactNode }) {
  return (
    <TooltipProvider>
      <SchemeSync />
      {children}
      <Toaster />
      <ConfirmHost />
    </TooltipProvider>
  )
}
